<template>
  <div class="home page">
    <video
      class="video_background"
      ref="vid"
      autoplay
      loop
      muted
      src="https://firebasestorage.googleapis.com/v0/b/journey-dev-e791c.appspot.com/o/People%20-%203606.mp4?alt=media&token=cf276665-4069-483e-946a-b9b59b5fced4"
    ></video>
    <div class="contain">
      <img class="logo" src="@/assets/img/logo.svg" />
      <card v-if="register" title="Register" class="login">
        <div class="inputs">
          <div class="input">
            <label>
              First Name
              <span>*</span>
            </label>
            <input ref="first_name" type="text" v-model="user.first_name" />
          </div>
          <div class="input">
            <label>
              Last Name
              <span>*</span>
            </label>
            <input ref="last_name" type="text" v-model="user.last_name" />
          </div>
          <div class="input">
            <label>
              Email Address
              <span>*</span>
            </label>
            <input ref="email" type="text" v-model="user.email" />
          </div>
          <div class="input">
            <label>
              Username
              <span>*</span>
            </label>
            <input ref="display_name" type="text" v-model="user.display_name" />
          </div>
          <div class="input">
            <label>
              Company Name
            </label>
            <input type="text" v-model="user.company" />
          </div>
          <div class="input">
            <label>
              Password
              <span>*</span>
            </label>
            <input ref="password" type="password" v-model="password" />
          </div>

          <div class="btns">
            <button @click="toggleComponent('login')" class="btn text_btn">
              Login Here
            </button>
            <button @click="sendForm" class="btn">register</button>
          </div>

          <p v-if="errors.length" ref="error" class="error"></p>
        </div>
      </card>
      <card v-if="login" title="Login" class="login">
        <div class="inputs">
          <div class="input">
            <label>
              Email
              <span>*</span>
            </label>
            <input ref="email" type="text" v-model="user.email" />
          </div>
          <div class="input">
            <label>
              Password
              <span>*</span>
            </label>
            <input ref="password" type="password" v-model="password" />
          </div>

          <div class="btns">
            <button @click="toggleComponent('forgot')" class="btn text_btn">
              Forgot Password?
            </button>
            <button @click="toggleComponent('register')" class="btn text_btn">
              Register Here
            </button>
            <button @click="sendForm" class="btn">Login</button>
          </div>

          <p v-if="errors.length" ref="error" class="error"></p>
        </div>
      </card>
      <card v-if="forgot_pass" title="Forgot Password" class="login">
        <div class="inputs">
          <div class="input full">
            <label>
              Email
              <span>*</span>
            </label>
            <input ref="email" type="text" v-model="user.email" />
          </div>
          <span :style="{ fontSize: '14px', margin: '0px 0 15px 0' }"
            >*Please enter the email associated with your account to request a
            password reset.</span
          >
          <div class="btns">
            <button @click="toggleComponent('register')" class="btn text_btn">
              Register Here
            </button>
            <button @click="toggleComponent('login')" class="btn text_btn">
              Login Here
            </button>
            <button @click="() => sendResetEmail()" class="btn">
              Submit Request
            </button>
          </div>
          <p v-if="errors.length" ref="error" class="error">{{ errors[0] }}</p>
          <p v-if="successMsg" class="success">{{ successMsg }}</p>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Card from "@/components/Section.vue";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "home",
  components: {
    card: Card,
  },
  data() {
    return {
      register: false,
      login: true,
      forgot_pass: false,
      errors: [],
      successMsg: "",
      user: {
        first_name: null,
        last_name: null,
        company: null,
        phone: null,
        email: null,
        address: {
          name: null,
          address_1: null,
          address_2: null,
          address_3: null,
          city: null,
          state: null,
          country: null,
        },
        access: {
          admin: true,
          exhibitor: false,
          attendee: false,
        },
      },
      password: null,
      errorMsgs: {
        first_name: "a first name",
        last_name: "a last name",
        display_name: "a username",
        email: "a valid email address",
        password: "a password",
      },
      thanks: false,
    };
  },
  firestore() {
    return {
      data: db.collection("data"),
    };
  },
  mounted() {
    this.$refs.vid.playbackRate = 0.5;
  },
  created() {},
  updated() {},
  methods: {
    sendResetEmail() {
      let auth = firebase.auth();
      let emailAddress = this.user.email;
      let vm = this;
      auth
        .sendPasswordResetEmail(emailAddress)
        .then(function() {
          vm.errors = [];
          vm.successMsg = "The request was sent successfully";
        })
        .catch(function(error) {
          vm.successMsg = "";
          vm.errors.push(error.message);
        });
    },
    toggleComponent(component) {
      if (component === "login") {
        this.login = true;
        this.register = false;
        this.forgot_pass = false;
      } else if (component === "register") {
        this.login = false;
        this.register = true;
        this.forgot_pass = false;
      } else {
        this.login = false;
        this.register - false;
        this.forgot_pass = true;
      }
    },
    sendForm() {
      let submit = true;
      this.errors = [];
      for (let ref in this.$refs) {
        if (ref != "error" && ref != "vid" && !this.$refs[ref].value) {
          if (ref == "email") {
            if (this.checkEmail()) {
              this.$refs[ref].classList.remove("error_msg");
            } else {
              this.$refs[ref].classList.add("error_msg");
              this.errors.push(ref);
              submit = false;
            }
          } else {
            this.$refs[ref].classList.add("error_msg");
            this.errors.push(ref);
            submit = false;
          }
        }
      }

      if (submit) {
        this.errors = [];
        if (this.register) {
          this.registerUser();
        } else {
          this.loginUser();
        }
      } else {
        this.listErrors();
      }
    },
    checkEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.user.email).toLowerCase());
    },
    listErrors() {
      this.$nextTick(() => {
        let msg = "Please enter ";
        this.errors.forEach((err, i) => {
          msg += this.errorMsgs[err];
          if (i + 1 < this.errors.length) {
            msg += ", ";
          } else {
            msg += ".";
          }
        });
        this.$refs.error.innerHTML = msg;
        setTimeout(() => {
          this.errors = [];
        }, 3000);
      });
    },
    registerUser() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.user.email, this.password)
        .then(
          (msg) => {
            this.createUser(msg.user.uid);
          },
          (err) => {
            alert(err.message);
          }
        );
    },
    createUser(id) {
      db.collection("user")
        .doc(id)
        .set(this.user)
        .then(() => {
          if (this.register) {
            let event_id = db
              .collection("user")
              .doc(id)
              .collection("events")
              .doc().id;
            this.$router.push("/event/" + event_id + "/content");
          } else {
            this.goTo("/events");
          }
        });
    },
    loginUser() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user.email, this.password)
        .then(
          (user) => {
            this.goTo("/events");
          },
          function(err) {
            alert("The credentials did not match a user");
          }
        );
    },
  },
};
</script>

<style lang="scss">
.home {
  padding-top: 0;
  position: relative;
  z-index: 6;
  top: 0;
  left: 0;
  background-color: white;
  width: 100%;

  .video_background {
    min-width: 100vw;
    min-height: 100vh;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    opacity: 0.15;
  }

  .btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;

    .btn {
      margin-left: 30px;
    }
  }

  .error {
    background: rgba(248, 48, 1, 0.15);
    padding: 10px 20px;
    color: #f83001;
  }

  .success {
    color: rgb(0, 169, 0);
    background-color: rgba(0, 252, 0, 0.201);
    padding: 10px 20px;
  }
  .logo {
    height: 40px;
    margin-right: auto;
  }

  .contain {
    max-width: 800px;
    min-height: 100vh;
    position: relative;
    z-index: 2;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1 {
      margin-bottom: 0;
    }

    .section {
      margin-top: 30px;

      .card {
        background: white;
        box-shadow: 0 0 8px rgba(128, 128, 128, 0.2);
      }
    }

    .section .inputs .input {
      input {
        background: #f7f7f7;
        box-shadow: none;
      }

      label {
        text-align: left;
      }
    }
  }
}
</style>
